export enum AvailableStatus {
  AVAILABLE = 'AVAILABLE',
  NOACD = 'NOACD',
  GOOUT = 'GOOUT',
  TYPING = 'TYPING',
  ATLUNCH = 'ATLUNCH',
  MEETING = 'MEETING',
  TRAINING = 'TRAINING',
  ONCAMPAIGN = 'ONCAMPAIGN',
  NOT_AVAILABLE = 'NOT AVAILABLE',
}
export const ArrayStatus = [
  AvailableStatus.AVAILABLE,
  AvailableStatus.NOACD,
  AvailableStatus.NOT_AVAILABLE,
  AvailableStatus.ATLUNCH,
  AvailableStatus.GOOUT,
  AvailableStatus.MEETING,
  AvailableStatus.ONCAMPAIGN,
  AvailableStatus.TYPING,
  AvailableStatus.TRAINING,
];



// WEBPACK FOOTER //
// ./src/app/layout/header/user-status/available.const.ts